import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_SETTINGS = {
  mentionPrefix: "@",
  mentionTrigger: "@",
  getMentionLink: () => "#",
  repositionSuggestions: true,
  entryHeight: 34,
  additionalHeight: 17,
  visibleItemsBeforeOverflow: 5,
  popoverComponent: /* @__PURE__ */ React.createElement("div", null),
  onMentionClick: (mention) => mention,
  getMentions: (searchQuery) => new Promise(
    (resolve) => setTimeout(
      () => resolve(
        [
          { name: "Test One", slug: "testone" },
          { name: "Test One.1", slug: "testone1" },
          { name: "Test One.2", slug: "testone2" },
          { name: "Test One.3", slug: "testone3" },
          { name: "Test One.4", slug: "testone4" },
          { name: "Test One.5", slug: "testone5" },
          { name: "Test One.6", slug: "testone6" },
          { name: "Test One.7", slug: "testone7" },
          { name: "Test One.8", slug: "testone8" },
          {
            name: "Test Two",
            slug: "testwo",
            avatar: "https://via.placeholder.com/100x100?text=Image=50"
          }
        ].filter(({ name }) => name.toLowerCase().includes(searchQuery.toLowerCase()))
      ),
      250
    )
  ),
  zIndex: 9999
};
const DEFAULTS = {
  config: __spreadValues({}, DEFAULT_SETTINGS)
};

export { DEFAULTS, DEFAULT_SETTINGS };
//# sourceMappingURL=defaultSettings.js.map
